import { render, staticRenderFns } from "./SimpleTest.vue?vue&type=template&id=2c5a99ff&"
import script from "./SimpleTest.vue?vue&type=script&lang=js&"
export * from "./SimpleTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports